import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { useTheme } from '@mui/material/styles';
import * as React from 'react';

export const RadioSelector = (props: {
  value: number | undefined;
  name: string;
  label?: string;
  valueFieldName: string;
  displayFieldName: string;
  options: any[];
  onChange: (value: number | undefined, name: string, error: string) => any;
}) => {
  const { onChange } = props;
  const theme = useTheme();

  const handleChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value =
        (event.target as HTMLInputElement).value === ''
          ? undefined
          : parseInt((event.target as HTMLInputElement).value);
      onChange(value, props.name, '');
    },
    [onChange, props.name]
  );

  return (
    <FormControl component="fieldset">
      {props.label ? (
        <FormLabel component="legend" style={{ marginRight: theme.spacing(2) }}>
          {props.label}
        </FormLabel>
      ) : null}
      <RadioGroup aria-label="gender" name={props.name} value={props.value?.toString() || ''} onChange={handleChange}>
        {props.options.map((a) => (
          <FormControlLabel
            key={a[props.valueFieldName]}
            value={a[props.valueFieldName].toString()}
            control={<Radio color="secondary" />}
            label={a[props.displayFieldName]}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};
